module.exports = __webpack_public_path__ + "img/l-6.9d11ba45.jpg";